import { Blockchain } from "@rarible/api-client"
import { etherlink } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const etherlinkConfig: StaticEthereumBlockchainConfig = {
  name: "Etherlink",
  icon: "/images/blockchains/etherlink.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://etherlink-api.rarible.org",
  chainId: etherlink.id,
  chainName: etherlink.name,
  blockchain: Blockchain.ETHERLINK,
  viem: etherlink,
  addFundsLink: "https://bridge.etherlink.com/evm",
  primaryCurrency: {
    id: toCurrencyId("ETHERLINK:0x0000000000000000000000000000000000000000"),
    symbol: "XTZ",
    name: "Tez",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ETHERLINK:0xc9b53ab2679f573e480d01e0f49e2b5cfb7a3eab"),
    symbol: "WXTZ",
    name: "Wrapped Tez",
    decimals: 18,
  },
  blockExplorers: [
    {
      url: "https://explorer.etherlink.com",
      icon: "/images/scanner.svg",
      adress: "https://etherlink.com/explorer/address/${adrress}",
    },
  ],
  feeConfigUrl: FEE_CONFIG_URL,
  rpcUrls: [],
  privateRpcNodeSlug: "etherlink-node",
  exchange: {
    v2: "0x5faf16A85028BE138A7178B222DeC98092FEEF97",
    wrapper: "0xF965237c6b3f89f8C62B45b94097899E3562A830",
  },
  transferProxies: {
    nft: "0xF65eF65a95821A16E02973b1C2200FA58898e3c0",
    erc721Lazy: "0xce4bf732f53A76C463aE8822be858017b02779c8",
    erc20: "0x248B46BEB66b3078D771a9E7E5a0a0216d0d07ba",
  },
  hasStabilityProtocol: true,
}

export const getEtherlinkConfig = (): StaticEthereumBlockchainConfig =>
  etherlinkConfig
